import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-caption text-disabled" }

import { useI18n } from 'vue-i18n'


export default {
  __name: 'GuestsAgeRange',
  props: {
  ageRange: {
    type: Object,
    required: true
  }
},
  setup(__props) {

const { t } = useI18n()



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.ageRange.minAge)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString(_unref(t)('Search#Form#Field#GuestsAge {minAge}-{maxAge} years old', __props.ageRange)), 1)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(_unref(t)('Search#Form#Field#GuestsAge Under {maxAge} years old', __props.ageRange)), 1)
        ], 64))
  ]))
}
}

}